import {
  getCPCBanner,
  postCPCBannerClick,
} from '../api/modules/Tasks/flyer_cpc';

interface DreamCoinBannerResponse {
  banner_id: string;
  title: string;
  description: string;
  image_url: string;
  link: string;
  data: any;
}

export interface BoostTask {
  data: any;
  id: any;
  title?: any;
  description?: any;
  provider: any;
  icon?: any;
  onClick: any;
}

export interface BoostProvider {
  getName(): string;
  getAvailableTasks(miningId: number): Promise<BoostTask[]>;
  startTask?(
    taskId: string | number,
  ): Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  resetError?(): void;
}

export class FlyerBoostProvider implements BoostProvider {
  private static instance: FlyerBoostProvider;
  private hasError: boolean = false;
  private lastTaskTime: number = 0;
  private readonly TASK_COOLDOWN = 5000;
  private currentBanner: DreamCoinBannerResponse | null = null;

  private constructor() {}

  public static getInstance(): FlyerBoostProvider {
    if (!FlyerBoostProvider.instance) {
      FlyerBoostProvider.instance = new FlyerBoostProvider();
    }
    return FlyerBoostProvider.instance;
  }

  private canShowNewTask(): boolean {
    return Date.now() - this.lastTaskTime >= this.TASK_COOLDOWN;
  }

  private isTelegramUrl(url: string): boolean {
    return url.includes('t.me/');
  }

  async startTask(
    taskId: string | number,
  ): Promise<'success' | 'ads_not_found' | 'user_cancelled'> {
    console.log('Starting Flyer task with ID:', taskId);
    console.log('Current banner:', this.currentBanner);

    if (!this.canShowNewTask()) {
      console.log('Cannot start Flyertask: on cooldown');
      return 'ads_not_found';
    }

    try {
      // Если нет текущего баннера или его ID не совпадает с taskId,
      // пробуем получить актуальный баннер
      console.log(this.currentBanner?.banner_id, 'currentBannerSSS');
      console.log('taskId:', taskId, 'type:', typeof taskId);
      if (
        !this.currentBanner ||
        !this.currentBanner.banner_id ||
        !taskId ||
        this.currentBanner.banner_id.toString() !== taskId.toString()
      ) {
        console.log('Getting new banner data...');
        const response = await getCPCBanner();
        const banner = response as DreamCoinBannerResponse;

        if (!banner?.data?.banner_id) {
          console.log('No valid banner data received');
          return 'ads_not_found';
        }

        this.currentBanner = banner.data;
      }

      if (!this.currentBanner?.link) {
        console.log('Cannot start Flyer task: no valid link in banner');
        return 'ads_not_found';
      }

      console.log('Opening link:', this.currentBanner.link);

      // Проверяем, является ли ссылка телеграм-ссылкой
      if (this.isTelegramUrl(this.currentBanner.link)) {
        window.Telegram?.WebApp.openTelegramLink(this.currentBanner.link);
      } else {
        window.Telegram?.WebApp.openLink(this.currentBanner.link);
      }

      // Отправляем информацию о клике

      this.lastTaskTime = Date.now();
      return 'success';
    } catch (error) {
      console.error('Error starting Flyer task:', error);
      this.hasError = true;
      return 'ads_not_found';
    }
  }

  async getAvailableTasks(): Promise<BoostTask[]> {
    // Сбрасываем ошибку при каждом новом запросе
    //ВОТ ТУТА СУКА
    // if(this.hasError){
    //   return[]
    // }

    this.hasError = false;

    try {
      const response = await getCPCBanner();
      const banner = response as any;

      if (!banner?.data?.banner_id) {
        console.log('No valid Flyer tasks found');
        return [];
      }

      // Сохраняем текущий баннер
      this.currentBanner = banner.data;
      console.log('Saved banner:', this.currentBanner);

      // Возвращаем только одно задание
      return [
        {
          data: banner,
          id: `${banner.data.banner_id}`,
          title: banner.data.title || 'Просмотреть рекламу',
          description: banner.data.description || '',
          provider: 'Flyer',
          icon: banner.data.image_url,
          onClick: async () => {
            // При клике выполняем действие
            return this.startTask(banner.data.banner_id);
          },
        } as any,
      ];
    } catch (error) {
      console.error('Error getting Flyer tasks:', error);
      this.hasError = true;
      return [];
    }
  }

  getName(): string {
    return 'Flyer';
  }

  resetError() {
    this.hasError = false;
    this.lastTaskTime = 0;
    this.currentBanner = null;
  }
}

// Экспортируем уже созданный экземпляр
export const flyerBoostProvider = FlyerBoostProvider.getInstance();
